import { render, staticRenderFns } from "./FolderDetailActions.vue?vue&type=template&id=27bc66f7&scoped=true"
import script from "./FolderDetailActions.vue?vue&type=script&lang=js"
export * from "./FolderDetailActions.vue?vue&type=script&lang=js"
import style0 from "./FolderDetailActions.vue?vue&type=style&index=0&id=27bc66f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bc66f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
